{
  "loading": "Nalaganje...",
  "loadingMore": "Nalaganje dodatne vsebine..."
}
